import { useRouter } from "next/router"
import React from "react"
import { useAppSelector } from "../../../state/store"

interface RedirectIfAuthenticatedProps {
  to: string
}

export const RedirectIfAuthenticated = ({
  to,
}: RedirectIfAuthenticatedProps) => {
  const { isAuthenticated } = useAppSelector((state) => state.user)
  const router = useRouter()
  React.useEffect(() => {
    if (isAuthenticated) {
      router.push(to)
    }
  }, [isAuthenticated])
  return <></>
}

interface RedirectIfAnonymousProps {
  to: string
}

export const RedirectIfAnonymous = ({ to }: RedirectIfAnonymousProps) => {
  const { isAnonymous } = useAppSelector((state) => state.user)
  const router = useRouter()
  React.useEffect(() => {
    if (isAnonymous) {
      router.push(to)
    }
  }, [isAnonymous])
  return <></>
}

export const RedirectToLoginIfAnonymous = () => {
  return <RedirectIfAnonymous to="/account/login" />
}
